// Cm3 prequalification content for /compliance — facts only, sourced from the Cm3 certificate.
export const CM3 = {
  id: "87225",
  expiry: "2026-10-02",
  verifyUrl: "https://www.cm3.com.au",
  capability: "General",
  scope: ["Subcontractors", "WHS System Documents"],
  publicLiability: "$20,000,000",
  workersComp: "Workers Compensation — NSW",
};

export const CM3_MEANING = [
  {
    title: "Independently verified WHS",
    text: "Cm3 is Australia's leading contractor WHS prequalification scheme. Our safety management system, insurances and risk review have been assessed by Cm3 — not self-declared.",
    icon: "ShieldCheck",
  },
  {
    title: "Procurement-ready for schools & councils",
    text: "Principals, facilities managers and council procurement teams can engage Speedy Resurfacing without a separate contractor vetting cycle — our Cm3 record is already on file.",
    icon: "Landmark",
  },
  {
    title: "Covered on every site",
    text: "Public Liability insurance of $20,000,000 and NSW Workers Compensation are verified within our Cm3 profile, so clubs, strata and private owners are protected from day one.",
    icon: "Umbrella",
  },
  {
    title: "Documented, repeatable safety",
    text: "Safe Work Method Statements, risk assessments and site inductions are part of the Speedy Method on every court — from mechanical grinding to final line marking.",
    icon: "ClipboardCheck",
  },
];

export const CM3_VERIFY_STEPS = [
  { title: "Open the Cm3 contractor portal", text: "Go to cm3.com.au and sign in with your organisation's Cm3 client account." },
  { title: "Search our Cm3 ID", text: "Enter Cm3 ID 87225 to open the Speedy prequalification record." },
  { title: "Review the live status", text: "Confirm the current risk-review status, insurance validity and WHS system documents directly from Cm3." },
];

export const CM3_FAQS = [
  {
    q: "Is Speedy Resurfacing Cm3 prequalified?",
    a: "Yes. Speedy Resurfacing is Cm3 prequalified under Cm3 ID 87225, with capability assessed for General works covering Subcontractors and WHS System Documents. Procurement teams can verify the record on the Cm3 portal.",
  },
  {
    q: "What is Cm3 and why does it matter for a court resurfacing project?",
    a: "Cm3 is an independent contractor WHS prequalification and compliance scheme used by Australian schools, councils, universities, property groups and facilities managers. It means our safety systems and insurances have been checked by a third party before we ever arrive on site — reducing your due-diligence workload and your risk.",
  },
  {
    q: "Does Cm3 prequalification cover insurance?",
    a: "Our Cm3 profile records Public Liability insurance of $20,000,000 and NSW Workers Compensation, with policy dates verified by Cm3.",
  },
  {
    q: "Can a school or council engage Speedy Resurfacing directly?",
    a: "Yes. Because we are already Cm3 prequalified, schools, councils and clubs that use Cm3 for contractor management can engage Speedy Resurfacing for court resurfacing, restoration, custom court design and line marking without a separate vetting round.",
  },
  {
    q: "How do I verify Speedy Resurfacing's Cm3 status?",
    a: "Sign in to the Cm3 portal with your organisation's client account and search Cm3 ID 87225. The live record shows our current prequalification status, risk-review expiry and insurance validity.",
  },
];
